module.exports = function () {
  return new Promise(function (resolve) {
    require.ensure([], function (require) {
      resolve(require("!!/Users/metamben/metabase-release/2023-08-08/metabase-oss/node_modules/babel-loader/lib/index.js??ruleSet[1].rules[0].use[0]!/Users/metamben/metabase-release/2023-08-08/metabase-oss/node_modules/source-map-loader/dist/cjs.js!/Users/metamben/metabase-release/2023-08-08/metabase-oss/frontend/src/metabase-lib/metadata/utils/ga-metadata.js"));
    });
  });
}